import { ref } from "vue";
import { useTaskCompletion } from "../../../composables/useTaskCompletion";

export function useTimeTrackerOverrun() {
  const { checkForTaskCompletion } = useTaskCompletion();

  // Task overrun dialog variables
  const showOverrunDialog = ref(false);
  const overrunTaskName = ref("");
  const overrunEstimatedDuration = ref(0);
  const overrunActualDuration = ref(0);

  // Success message variables
  const showSuccessMessageDialog = ref(false);
  const successTaskName = ref("");
  const successAccuracy = ref(0);

  function closeOverrunDialog() {
    showOverrunDialog.value = false;
  }

  function saveOverrunReasons(
    reasons: string[],
    tasks: any[],
    updateTasks: (tasks: any[]) => void
  ) {
    console.log("Received overrun reasons (IDs):", reasons);

    // Find the task that was just completed and save the overrun reasons
    const task = tasks.find(
      (t) =>
        t.name === overrunTaskName.value &&
        t.estimatedDuration === overrunEstimatedDuration.value &&
        t.duration === overrunActualDuration.value
    );

    if (task) {
      const updatedTask = { ...task, overrunReasons: reasons };
      const updatedTasks = tasks.map((t) =>
        t.id === task.id ? updatedTask : t
      );
      updateTasks(updatedTasks);
      console.log("Saved overrun reasons for task:", task.name, reasons);

      // Verify the data structure
      console.log("Updated task overrunReasons:", updatedTask.overrunReasons);
    }

    showOverrunDialog.value = false;
  }

  function skipOverrunDialog() {
    showOverrunDialog.value = false;
  }

  function handleTaskCompletion(task: any) {
    const completionResult = checkForTaskCompletion(task);

    if (completionResult) {
      if (completionResult.isOverrun) {
        // Task is overrun - show overrun dialog
        overrunTaskName.value = completionResult.taskName;
        overrunEstimatedDuration.value = completionResult.estimatedDuration;
        overrunActualDuration.value = completionResult.actualDuration;
        showOverrunDialog.value = true;
      } else {
        // Task is on time - show success message based on accuracy
        successTaskName.value = completionResult.taskName;
        successAccuracy.value = completionResult.accuracy || 0;
        showSuccessMessageDialog.value = true;

        // Hide the success message after it's shown
        setTimeout(() => {
          showSuccessMessageDialog.value = false;
        }, 3000);
      }
    }
  }

  return {
    showOverrunDialog,
    overrunTaskName,
    overrunEstimatedDuration,
    overrunActualDuration,
    showSuccessMessageDialog,
    successTaskName,
    successAccuracy,
    closeOverrunDialog,
    saveOverrunReasons,
    skipOverrunDialog,
    handleTaskCompletion,
  };
}
